export default "__VITE_ASSET__Bev32tIe__"